import { render } from "./ABTable.vue?vue&type=template&id=52985fb6"
import script from "./ABTable.vue?vue&type=script&lang=js"
export * from "./ABTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__